import React from 'react';
import styled from 'styled-components/macro';
import { Divider, Grid } from '@mui/material';
import { translations } from '../../../../../locales/translations';
import { useTranslation } from 'react-i18next';
import { DisplayFieldVertical } from '../DisplayFieldVertical';
import { WaiverTable } from './WaiverTable';
import { useSelector } from 'react-redux';
import { selectCurrency } from '../../slice/selectors';
import { commonStyle } from '../../../../../styles/theme/themes';
import { DisplayFieldHorizontal } from '../DisplayFieldHorizontal';
import moment from 'moment';
export function WaiveCard(props) {
  const { t } = useTranslation();
  const waiverData = props.data.data;
  const currency = useSelector(selectCurrency);

  const directToURL = () => {
    if (waiverData.workflowURL) {
      window.open(waiverData.workflowURL, '_blank');
    }
  };

  return (
    <Wrapper>
      {waiverData &&
      <div className='wrap'>
        <Grid container className='header'>
          <Grid item md={4}>
            {t(translations.contractDetail.amendment.waiver.waiver)}
          </Grid>
          <Grid item md={4} className='center workflow-url' onClick={directToURL}>
            {waiverData.workflowId}
          </Grid>
        </Grid>
        <Divider />
        <div className='content'>
          <DisplayFieldHorizontal
            label={translations.contractDetail.amendment.approvalDate}
            value={moment(waiverData.approvalDate).format('YYYY-MM-DD HH:mm:ss')}
          />
          <Grid container className='row'>
            <Grid item xs={12} md={12} lg={6}>
              <DisplayFieldVertical
                label={translations.contractDetail.amendment.waiver.totalWaiveAmount}
                value={`${currency} ${Number(waiverData.totalWaiveAmount).toLocaleString(
                  undefined,
                  { maximumFractionDigits: 2 },
                )}`}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <DisplayFieldVertical
                label={translations.contractDetail.amendment.waiver.totalWaiveDeposit}
                value={`${currency} ${Number(waiverData.totalWaiveDeposit).toLocaleString(
                  undefined,
                  { maximumFractionDigits: 2 },
                )}`}
              />
            </Grid>
          </Grid>
          <WaiverTable contractLineData={waiverData.products} />
        </div>
      </div>
      }
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .wrap {
    padding: 5px;
    margin: 5px 0;
    border-radius: 5px;
    box-shadow: ${commonStyle.boxShadow};
    background-color: ${p => p.theme.borderLight};
  }

  .header {
    background-color: ${p => p.theme.borderLight};

    .workflow-url {
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        opacity: 0.8;
      }
    }

    .center {
      text-align: center;
    }

    .right {
      text-align: right;
    }
  }

  .content {
    background-color: white;
    padding-top: 5px;
  }
`;
